// @ts-expect-error
import experimentFactory from '@wix/santa-main-r/lib/lib/common/experimentFactory'
import {getQueryUtils, PackagesUtil, getRjsConfig, RjsPkg} from './main-r'
import * as santa from '@wix/santa-ds-libs/src/santa'
import {checkConfig} from './checkConfig'
import {loadScript} from './utils'
import {externalsForRjsMapping} from '../externals.mjs'

function genUnpkgUrl(packageName: string, version: string, path: string): string {
    return `https://static.parastorage.com/unpkg/${packageName}@${version}/${path}`
}

const loadRequireJs = async () => {
    if (!window.requirejs) {
        await loadScript(
            'https://static.parastorage.com/services/third-party/requirejs/2.1.15/require.min.js',
            'requirejs'
        )
    }
}

declare global {
    interface Window {
        define(name: string, cb: Function): void
        requirejs: {
            config(s: any): void
            (deps: string[], cb: Function): void
        }
        React: any
        ReactDOM: any
        pmrpc: any
        _: any
        queryUtils: any
        zepto: any
        experiment: any
        immutable: any
    }
}

const santaUnpkg = (p: string) => genUnpkgUrl('@wix/wix-santa', santa.version, p)

const fixSantaPaths = (paths: Record<string, string>, packages: RjsPkg[]) => {
    packages.forEach((p: RjsPkg) => {
        //p.location = `https://localhost:8080/node_modules/@wix/wix-santa/${p.location}`
        p.location = santaUnpkg(p.location!)
    })
    const fixedPaths = checkConfig(paths)
    return fixedPaths
}

const defineExperimentInstance = () => {
    const experiments: string = window.queryUtils.getParameterByName('experiments')
    experiments.split(',').forEach(name => {
        window.rendererModel.runningExperiments[name] = 'new'
    })
    const experimentInst = experimentFactory.build(window)
    window.define('experiment', () => experimentInst)
    window.define('experiment-amd', () => experimentInst)
    return experimentInst
}

const main = async () => {
    await loadRequireJs()
    const queryUtils = getQueryUtils(window)
    window.queryUtils = queryUtils
    const isDebug = !!queryUtils.getParameterByName('debug')
    const experimentInstance = defineExperimentInstance()
    const versions = {...santa.options.versions}
    if (experimentInstance.isOpen('dm_react18')) {
        versions.react = '18.3.1'
        versions['react-dom'] = '18.3.1'
    }
    const rjsConfig = getRjsConfig(versions, window.serviceTopology, false, {} as any)
    rjsConfig.paths!.mainScript = `${window.dmBase}/tb-main/dist/tb-main-internal${isDebug ? '' : '.min'}`
    const packagesUtil = new PackagesUtil([], window.location.search)
    const {paths, packages, map, shim, bundles} = packagesUtil.buildConfig(rjsConfig)
    const fixedPaths = fixSantaPaths(paths! as Record<string, string>, packages!)
    map!['*']['pm-rpc'] = 'pmrpc'
    window.requirejs.config({
        paths: fixedPaths,
        packages,
        map,
        shim,
        waitSeconds: 60,
        bundles
    })

    const externals = externalsForRjsMapping()
    const packageNames = Object.keys(externals)

    window.requirejs(packageNames, (...values: any[]) => {
        for (let i = 0; i < packageNames.length; i++) {
            const packageName = packageNames[i]
            const pkg = values[i]
            const alias = externals[packageName]!
            window[alias] = pkg
        }

        window.requirejs(['mainScript'], () => {})
    })
}

main()
